import { gql } from "@apollo/client";

export const SEND_OTP = gql`
mutation otpSignUp($data: OtpSignUpInput!){
    otpSignUp(data: $data){
      success
      messages
    }
  }
`;

export const VERIFY_OTP = gql`
mutation otpVerify($data: OtpVerifyInput!){
    otpVerify(data: $data){
    user {
            objectUserId
            firstName
            lastName
            image
            countryCode
            phone
            email
            channelFoundUs
            isEmailConfirmed
            acceptedTerms
            location
            id
            address
            placeId
            contact_id
            email_id
            fireBasePhone
            wellnessModal
        }
      scope
      token_type
      custom_token
      refresh_token
      expires_in
      success
      messages
    }
  }
`;

